export { TITLE, PASSPORT, DIPLOMAS, APPLICATION } from './constants'
export type { TLeastDocumentsProps } from './types'
